/**
 * The client's numbers: how often a quiet socket is checked, and how long the slow requests may
 * take before they count as lost (milliseconds).
 */

/** Time between two keepalive pings (ms). */
export const KEEPALIVE_MS = 25_000;

/**
 * Requests that may take longer than the usual timeout, with their own limit (ms). Mirrors
 * `Request::time_limit` in the core (plus a little, so the core's own timeout answers first).
 */
export const SLOW_REQUESTS: Partial<Record<Request["method"], number>> = {
  "analyze.scan": 125_000,
  "analyze.scan_files": 125_000,
  // Fetching a repository (up to five minutes) and then scanning it.
  "repos.scan": 485_000,
  // Checking a plugin compiles it (a few seconds for a big one).
  "plugins.install": 65_000,
  // A plugin call runs the plugin a few times, sending its requests in between (the core gives up after 120 s).
  "plugins.call": 125_000,
  "plugins.command": 125_000,
  "plugins.view": 125_000,
  "plugins.action": 125_000,
  // An AI can think for minutes on a big graph (the core gives up after 300 s).
  "ai.suggest": 305_000,
  "ai.test": 305_000,
};
